import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';

import { WeedsToolbar, WeedsTable } from './components';
import api from 'services/api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const CustomerList = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [users, setCustomers] = useState([]);
  const [measurements, setMeasurements] = useState([]);

  const fetchWeeds = useCallback(async () => {
    try {
      const response = await api.get('products')

      setCustomers(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, setCustomers]);

  const fetchMeasurements = useCallback(async () => {
    try {
      const response = await api.get('measurements')

      setMeasurements(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, setMeasurements]);

  useEffect(() => {
    fetchWeeds();
    fetchMeasurements();
  }, [fetchWeeds, fetchMeasurements]);

  return (
    <div className={classes.root}>
      <WeedsToolbar measurements={measurements} fetchList={fetchWeeds} />
      <div className={classes.content}>
        <WeedsTable users={users} measurements={measurements} onFetch={fetchWeeds} />
      </div>
    </div>
  );
};

export default CustomerList;
